import routes from '@/config/routes';
import type {
  ICancelInterviewPayload,
  ICopyInterviewSlot,
  IInterviewNotePayload,
  IInterviewScorePayload,
  IInterviewSlot,
  IRescheduleInterviewPayload,
  IRescheduleInterviewSPPayload,
  IUpcomingInterviewPayload,
} from '@/store/types';
import { v3Get, v3Patch, v3Post } from '@/api/axios.instance.V3';
import type { ApiResponse } from '@/api/types';

const getInterviewSlotsByDate = (payload: any): ApiResponse => {
  return v3Post(`${routes.backendUrl.interviews.getSlotsByDate}/campaign`, payload);
};
const saveInterviewSlots = (payload: IInterviewSlot): ApiResponse => {
  return v3Post(`${routes.backendUrl.interviews.saveInterviewSlots}`, payload);
};
const copyInterviewSlots = (payload: ICopyInterviewSlot): ApiResponse => {
  return v3Post(`${routes.backendUrl.interviews.copyInterviewSlots}`, payload);
};
const getInterviewSlotsCount = (campaignId: number, dateStart: string, dateEnd: string): ApiResponse => {
  return v3Get(`${routes.backendUrl.interviews.getSlotsByDate}/${dateStart}/${dateEnd}/campaign/${campaignId}/count`);
};
const getInterviewNotes = (interviewId: number): ApiResponse => {
  return v3Get(`${routes.backendUrl.interviews.getInterviewNotes}/${interviewId}/notes`);
};

const getUpcomingInterviewList = (payload: IUpcomingInterviewPayload): ApiResponse => {
  return v3Post(`${routes.backendUrl.upcomingInterviews.interviewList}`, payload);
};
const getInterviewerList = (campaignId: number, applicationStatusId: number): ApiResponse => {
  return v3Get(
    `${routes.backendUrl.upcomingInterviews.interviewerList}/${campaignId}/interviewer/list?applicationStatusId=${applicationStatusId}`,
  );
};
const cancelUpcomingInterview = (payload: ICancelInterviewPayload): ApiResponse => {
  return v3Patch(`${routes.backendUrl.upcomingInterviews.cancelInterview}`, payload);
};
const rescheduleUpcomingInterview = (payload: IRescheduleInterviewPayload): ApiResponse => {
  return v3Post(`${routes.backendUrl.upcomingInterviews.rescheduleInterview}`, payload);
};
const rescheduleUpcomingInterviewSP = (payload: IRescheduleInterviewSPPayload): ApiResponse => {
  return v3Post(`${routes.backendUrl.upcomingInterviews.rescheduleInterviewSP}`, payload);
};
const getInterviewDetail = (interviewId: number): ApiResponse => {
  return v3Get(`${routes.backendUrl.upcomingInterviews.interviewDetail}/${interviewId}`);
};
const getInterviewAttendance = (): ApiResponse => {
  return v3Get(`${routes.backendUrl.upcomingInterviews.interviewAttendance}`);
};
const saveInterviewScore = (payload: IInterviewScorePayload): ApiResponse => {
  return v3Post(`${routes.backendUrl.upcomingInterviews.saveInterviewScore}`, payload);
};
const addInterviewNote = (payload: IInterviewNotePayload): ApiResponse => {
  return v3Post(`${routes.backendUrl.upcomingInterviews.addInterviewNote}`, payload);
};
const getInterviewSummary = (interviewId: number): ApiResponse => {
  return v3Get(`${routes.backendUrl.interviews.getInterviewSummary.replace('{interviewId}', interviewId.toString())}`);
};
const getShowInterviewDetails = (interviewId: number): ApiResponse => {
  return v3Get(
    `${routes.backendUrl.interviews.getShowInterviewDetails.replace('{interviewId}', interviewId.toString())}`,
  );
};

export const interviewsApi = {
  getInterviewSlotsByDate,
  saveInterviewSlots,
  copyInterviewSlots,
  getInterviewSlotsCount,
  getInterviewNotes,
  getUpcomingInterviewList,
  getInterviewerList,
  cancelUpcomingInterview,
  rescheduleUpcomingInterview,
  rescheduleUpcomingInterviewSP,
  getInterviewDetail,
  getInterviewAttendance,
  saveInterviewScore,
  addInterviewNote,
  getInterviewSummary,
  getShowInterviewDetails,
};
